﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyBurnPoolContract = exports.BuyBurnPoolContractStatisticStruct = void 0;
const BuyBurnPoolABI_1 = require("./abi/BuyBurnPoolABI");
const ContractFacade_1 = require("./abstact/ContractFacade");
const App_1 = require("../App");
class BuyBurnPoolContractStatisticStruct {
}
exports.BuyBurnPoolContractStatisticStruct = BuyBurnPoolContractStatisticStruct;
class BuyBurnPoolContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, BuyBurnPoolABI_1.BuyBurnPoolABI.GetABI());
    }
    getPriceATH() {
        return __awaiter(this, void 0, void 0, function* () { const value = yield this._call("priceATH"); return this._toEther(value); });
    }
    getLastUpdateTimestamp() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("lastUpdateTimestamp"); });
    }
    getForSwapUSDL() {
        return __awaiter(this, void 0, void 0, function* () { const value = yield this._call("forSwapUSDL"); return this._toEther(value); });
    }
    getPreBnBSeqTimestamp() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("preBnBSeqTimestamp"); });
    }
    getBotPriority() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("botPriority"); });
    }
    getStatistics() {
        return __awaiter(this, void 0, void 0, function* () {
            const respose = yield this._call("statistics");
            if (!respose)
                return respose;
            respose.lastBoughtAmountUSDL = this._toEther(respose.lastBoughtAmountUSDL);
            respose.totalBoughtAmountUSDL = this._toEther(respose.totalBoughtAmountUSDL);
            respose.totalBurnUp = this._toEther(respose.totalBurnUp);
            return respose;
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._send("update"); });
    }
    needUpdate() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._callInSilence("needUpdate"); });
    }
    checkUpdateWorkable() {
        return __awaiter(this, void 0, void 0, function* () {
            var account = yield App_1.App.Inst.chain.getAccountAsync();
            try {
                let gas = yield this._contract.methods["update"]().estimateGas({ from: account });
                return true;
            }
            catch (e) {
                return false;
            }
        });
    }
    getBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getBalance");
            return this._toEther(res);
        });
    }
    getBalanceToken(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getBalanceToken", address);
            return this._toEther(res);
        });
    }
    getStakedUSDL() {
        return __awaiter(this, void 0, void 0, function* () { const value = yield this._call("getStakedUSDL"); return this._toEther(value); });
    }
    getStakedLOAN() {
        return __awaiter(this, void 0, void 0, function* () { const value = yield this._call("getStakedLOAN"); return this._toEther(value); });
    }
    getPendingGainForUSDL() {
        return __awaiter(this, void 0, void 0, function* () { const value = yield this._call("getPendingGainForUSDL"); return { loan: this._toEther(value.loan + ""), pls: this._toEther(value.pls + "") }; });
    }
    getPendingGainForLOAN() {
        return __awaiter(this, void 0, void 0, function* () { const value = yield this._call("getPendingGainForLOAN"); return { usdl: this._toEther(value.usdl + ""), pls: this._toEther(value.pls + "") }; });
    }
}
exports.BuyBurnPoolContract = BuyBurnPoolContract;
//# sourceMappingURL=BuyBurnPoolContract.js.map